export const PageHero = ({ img, alt, eyebrow, title, subtitle, children, testId }) => (
  <section className="relative min-h-[340px] md:min-h-[420px] flex items-end overflow-hidden" data-testid={testId}>
    <img src={img} alt={alt} className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F]/90 via-[#0A192F]/60 to-[#0A192F]/20" />
    <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-[#0A192F]/50 to-transparent" />
    <div className="relative container-x w-full pt-28 pb-12 md:pb-16">
      <p className="text-xs uppercase tracking-[0.3em] font-semibold text-aqua">{eyebrow}</p>
      <h1 className="mt-4 max-w-3xl font-display text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05]">{title}</h1>
      {subtitle && <p className="mt-4 max-w-2xl text-base md:text-lg text-slate-200 leading-relaxed">{subtitle}</p>}
      {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, subtitle, children }) => (
  <div className="flex flex-col md:flex-row md:items-end justify-between gap-5">
    <div className="max-w-2xl">
      <p className="eyebrow">{eyebrow}</p>
      <h2 className="mt-3 font-display text-4xl sm:text-5xl text-navy font-semibold leading-tight">{title}</h2>
      {subtitle && <p className="mt-3 text-slate-600 leading-relaxed">{subtitle}</p>}
    </div>
    {children}
  </div>
);
